<script lang="ts">
	import { Snapshot, DataHandlerSnapshot } from "luxedo-data"
	import SnapshotInstance from "./SnapshotInstance.svelte"
	import { mobileScrollFade, Responsive } from "responsive"

	interface Props {
		snapshotIds: Array<number>
		selectedSnapshotId: Snapshot["id"]
		onselect: (snapshot: Snapshot) => void
	}

	let { snapshotIds, selectedSnapshotId, onselect }: Props = $props()

	let snapshots = $derived(snapshotIds.map((id) => DataHandlerSnapshot.get(id)))
	let isMobile = $derived(Responsive.isMobile)
</script>

<div class="snapshot-selector-container" class:isMobile>
	<div class="scrollable-snapshots" use:mobileScrollFade>
		<div class="snapshot-selector">
			{#each snapshots as snapshot (snapshot.id)}
				<SnapshotInstance
					{snapshot}
					onselect={() => onselect(snapshot)}
					selected={selectedSnapshotId === snapshot.id}
				/>
			{/each}
		</div>
	</div>
</div>

<style>
	.snapshot-selector-container {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		gap: 1rem;
	}

	.scrollable-snapshots {
		height: 100%;
		display: flex;
		flex-direction: column;
		overflow-y: scroll;
	}

	.snapshot-selector {
		flex-grow: 1;
		width: 100%;
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		grid-auto-rows: min-content;
		gap: 0.5rem;
		padding: 0.25rem;
	}

	.isMobile .snapshot-selector {
		grid-template-columns: 1fr 1fr;
	}
</style>
